import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import ContentBox from './ContentBox';


export default function Accordion({ header, subHeader, children, ...props }) {
    const defaultStyles = {
        mt: 2,
        mb: 3
    };

    const contentBoxProps = {
        ...props,
        sx: { ...props.sx, defaultStyles }
    };

    return (
        <>
            <Box sx={{pt: 6}}>
                <Typography variant="h4">{header}</Typography>
                { subHeader && <Typography sx={{mt: 1}} variant="body1">{subHeader}</Typography> }
            </Box>

            <ContentBox {...contentBoxProps}>{children}</ContentBox>
        </>
    );
}